// Usage: import { getCheckoutUrl } from '@/composables/useLemonSqueezyCheckout';

export function getCheckoutUrl(item, options = {}) {
  // Use buy_now_url from the variant or product object
  let url = null;

  if (item && item.attributes && item.attributes.buy_now_url) {
    url = item.attributes.buy_now_url;
  }

  if (!url) {
    console.error('[LemonSqueezy Checkout] No buy_now_url found in item:', item);
    return null;
  }

  // Map standard fields to Lemon Squeezy's expected query keys
  const mappedOptions = { ...options };
  if (mappedOptions.email) {
    mappedOptions['checkout[email]'] = mappedOptions.email;
    delete mappedOptions.email;
  }
  if (mappedOptions.name) {
    mappedOptions['checkout[name]'] = mappedOptions.name;
    delete mappedOptions.name;
  }

  // Optionally add query params (e.g., email, custom data)
  if (mappedOptions && Object.keys(mappedOptions).length > 0) {
    const separator = url.includes('?') ? '&' : '?';
    const params = new URLSearchParams(mappedOptions).toString();
    url += `${separator}${params}`;
  }

  return url;
}
